import { createTimestampGenerator } from '../../../utils/trace-format';
import type { ISlideInitialData } from '../../../core/interfaces/slide-initial-data-service.interface';
import type { ILogger } from '../../../core/slide-data-services.core';
import type { IOnlineEditDataFetcher } from '../core/interfaces/online-edit-data-fetcher.interface';
import { EditEvents, IEditEvents } from '../../../core/interfaces/event.interface';
import { ILoadLog, IOnlineEditService } from '../core/interfaces/online-edit-service.interface';

const MODULE = '[OnlineEditService]';

export class OnlineEditService implements IOnlineEditService {
    public constructor(
        private logger: ILogger,
        private fetcher: IOnlineEditDataFetcher,
        private emitter: IEditEvents,
    ) {
        this.logger.info(MODULE, '[init]');
    }

    /**
     * 获取 web3.0 打开文档的内容数据
     * 数据异常则返回null，后续展示默认空ppt
     */
    public loadDocument = async (): Promise<ISlideInitialData> => {
        const timestamp = createTimestampGenerator(true);
        this.logger.info(MODULE, '[load:begin]', timestamp());
        const loadLog: ILoadLog = {
            head: 0,
            chunk: 0,
            count: 0,
            total: 0,
        };
        return this.fetcher.loadPresentation({
            onHead: (total) => {
                const { now, last, timeline } = timestamp();
                this.logger.info(MODULE, '[load:head]', `[1/${total}]`, timeline);
                loadLog.head = last - now;
            },
            onChunk: (index, total) => {
                const { now, last, timeline } = timestamp();
                this.logger.info(MODULE, '[load:chunk]', `[${index + 1}/${total}]`, timeline);
                loadLog.chunk += last - now;
                loadLog.count = total;
            },
            onEnd: () => {
                this.logger.info(MODULE, '[load:end]', timestamp());
                this.emitter.emit(EditEvents.LoadDocumentAllChunksSuccess, loadLog);
            },
            onFatalError: (error) => {
                this.logger.error(MODULE, '[load:error]', error, timestamp());
                this.emitter.emit(EditEvents.LoadDocumentError, error);
            },
        });
    };
}
